<template>
  <button v-for="b in buttons" :key="b.id" class="secondary" @click.stop="enter(b.id)">
    {{ b.label }}
    <small v-if="b.progress" class="team-progress">{{ b.progress }}</small>
  </button>
</template>

<script>
// "With <friend>" for each room I made or joined by code for this date or
// Giant and haven't finished (Matt 2026-10-27: a Giant shared with a friend
// had no way back from home but its code). Reads each room's meta live, so
// a friend who joins later shows up by name, and how far the room has got
// (Sky, 2026-10-30).
import { mapState, mapGetters } from 'vuex';
import { watchRoomMeta } from '@/store/rooms';
import { roomIdsFor, roomButtons } from '@/utils/myRooms';

export default {
  name: 'MyRoomButtons',
  props: {
    date: { type: String, required: true },
  },
  data() {
    return { metas: {}, now: Date.now() };
  },
  computed: {
    ...mapState(['myRooms']),
    ...mapGetters(['myUid']),
    ids() { return roomIdsFor(this.myRooms, this.date); },
    buttons() { return roomButtons(this.ids, this.metas, this.myUid, this.now); },
  },
  watch: {
    ids: { immediate: true, handler(ids) { this.bind(ids); } },
  },
  mounted() {
    this.ticker = setInterval(() => { this.now = Date.now(); }, 1000);
  },
  beforeUnmount() {
    this.bind([]);
    clearInterval(this.ticker);
  },
  methods: {
    bind(ids) {
      // The immediate watcher runs before created(), so offs starts here.
      this.offs = this.offs || {};
      for (const id of Object.keys(this.offs)) {
        if (!ids.includes(id)) { this.offs[id](); delete this.offs[id]; delete this.metas[id]; }
      }
      for (const id of ids) {
        if (!this.offs[id]) this.offs[id] = watchRoomMeta(id, (meta) => { this.metas = { ...this.metas, [id]: meta }; });
      }
    },
    enter(roomId) { this.$store.dispatch('enterMyRoom', roomId); },
  },
};
</script>

<style lang="scss" scoped>
.team-progress { display: block; font-size: 0.75rem; font-weight: 600; opacity: 0.8; font-variant-numeric: tabular-nums; }
</style>
